import React from 'react';
import { ViewMode } from '../../types/category';
import styles from '../../styles/shared/ViewToggle.module.css';

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
  return (
    <div className={styles.viewToggle}>
      <button
        className={`${styles.toggleButton} ${currentView === 'table' ? styles.active : ''}`}
        onClick={() => onViewChange('table')}
        title="Table View"
      >
        <span className={styles.icon}>📋</span>
        <span className={styles.label}>Table</span>
      </button>
      
      <button
        className={`${styles.toggleButton} ${currentView === 'cards' ? styles.active : ''}`}
        onClick={() => onViewChange('cards')}
        title="Card View"
      >
        <span className={styles.icon}>🃏</span>
        <span className={styles.label}>Cards</span>
      </button>
    </div>
  );
};

export default ViewToggle; 